import React from 'react';
import { Span } from './types';

// Linked copy arrives as spans rather than markup, so links stay data all the way
// from extraction to render (no dangerouslySetInnerHTML anywhere in this package).
export default function RichText({ spans }: { spans: Span[] }) {
  return (
    <p className="pc-lesson-p">
      {spans.map((span, i) => (span.href ? (
        <a
          /* eslint-disable-next-line react/no-array-index-key */
          key={i}
          className="pc-lesson-link"
          href={span.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {span.text}
        </a>
      ) : (
        /* eslint-disable-next-line react/no-array-index-key */
        <React.Fragment key={i}>{span.text}</React.Fragment>
      )))}
    </p>
  );
}
